import React from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowDown } from "react-icons/fa";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import Card from "../../components/Card";
import Videos from "../../components/Videos";
import Clients from "../../components/Clients";
import Carousel from "../../components/Carousel";
import AdvertisingHeader from "../../components/AdvertisingHeader";
import { CustomDesignSection } from "../../components/CustomDesignSection";
import marketingPageLaurel from "../../Assets/laurel wreath - marketing page.svg";
import { ClientSection, FAQSection, ReachOutSection } from "../../components/BottomSection";
import { useCatalogListingPage } from "./useCatalogListingPage";
import { catalogSortOptions } from "./catalogConfigs";
import { DesigningCategoryButtons } from "./DesigningCategoryButtons";
import { PrintingCategoryButtons } from "./PrintingCategoryButtons";

export const CatalogPage = ({ config }) => {
  const navigate = useNavigate();
  const {
    category,
    clientsCategory,
    videosCategory,
    faqItems,
    reachOut,
    searchPlaceholder,
    emptyMessage,
    showFilterOptions,
    loading,
    items,
    error,
    sortBy,
    searchInput,
    showSortDropdown,
    selectedFilters,
    pagination,
    hasMore,
    visibleItems,
    totalVisibleItems,
    filterOptions,
    setSearchInput,
    setShowSortDropdown,
    handleSortClick,
    handleFilterChange,
    loadMore,
    getCardId,
  } = useCatalogListingPage(config);
  const supportingGraphic =
    category === "printing" ? marketingPageLaurel : "/clients.svg";

  const printingData = {
    clients: 800,
    years: 7,
    projects: "2 Lakh",
    awards: 3
  }

  const designData = {
    clients: 450,
    years: 7,
    projects: "3 Lakh",
    awards: 5
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Error</h2>
        <p className="text-gray-600 mb-6">{error}</p>
        <button
          onClick={() => navigate(-1)}
          className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="homepage">
      <Navbar />
      <Carousel />

      <div className="digital-section">
        <div className="digital">
          <div className="mx-auto w-full max-w-[92vw] sm:max-w-[88vw] xl:max-w-[80vw]">
            <AdvertisingHeader
              category={category}
              sortOptions={catalogSortOptions}
              showFilterOptions={showFilterOptions}
              showSearch
              sortBy={sortBy}
              handleSortClick={handleSortClick}
              showSortDropdown={showSortDropdown}
              setShowSortDropdown={setShowSortDropdown}
              selectedFilters={selectedFilters}
              searchValue={searchInput}
              onSearchChange={setSearchInput}
              searchPlaceholder={searchPlaceholder}
              onFilterChange={handleFilterChange}
              filterOptions={filterOptions}
            />
            {category === "designing" && (
              <div className="-mt-4">
                <DesigningCategoryButtons
                  selectedType={selectedFilters.type}
                  onFilterChange={handleFilterChange}
                />
              </div>
            )}
            {category === "printing" && (
              <div className="-mt-4">
                <PrintingCategoryButtons
                  selectedType={selectedFilters.type}
                  onFilterChange={handleFilterChange}
                />
              </div>
            )}
            <p className="px-4 pt-1 text-sm text-gray-600 sm:text-base">
              Showing {totalVisibleItems} of {pagination.total} results
            </p>
          </div>
        </div>
      </div>

      <section className="py-4 sm:py-6">
        <div className="mx-auto w-full max-w-[92vw] px-0 sm:max-w-[88vw] sm:px-2 lg:px-4 xl:max-w-[80vw]">
          {items.length === 0 && !loading ? (
            <div className="text-center py-8">
              <p className="text-gray-600">{emptyMessage}</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 md:grid-cols-3 lg:grid-cols-4 lg:gap-6">
              {visibleItems.map((item, index) => (
                <Card
                  key={item.id || item._id || item.slug}
                  data={item}
                  category={category}
                  disableHoverAnimation
                  id={getCardId(item, index)}
                />
              ))}
            </div>
          )}

          {hasMore ? (
            <div className="flex justify-center mt-8">
              <button
                onClick={loadMore}
                className="flex items-center px-6 py-2 bg-red-700 text-white rounded-lg hover:bg-red-800 transition-colors duration-300 ease-in-out focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50"
              >
                Load More
                <FaArrowDown className="ml-2" />
              </button>
            </div>
          ) : null}

          {loading ? (
            <div className="flex justify-center mt-8">
              <div className="w-12 h-12 border-4 border-red-600 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : null}
        </div>
      </section>

      <div className="mx-auto mb-2 mt-6 grid w-full max-w-[92vw] gap-4 sm:mb-3 sm:mt-8 sm:max-w-[88vw] xl:max-w-[80vw]">
        {category === "printing" ? (
          <CustomDesignSection config={printingData} />
        ) : (
          <CustomDesignSection config={designData} />
        )}
      </div>
      <div className="mt-6 sm:mt-8">
        <Clients category={clientsCategory} />
      </div>
      <Videos category={videosCategory} />
      <FAQSection pageFAQ={faqItems} />
      <div className="-mt-16 -mb-6">
        <ClientSection />
      </div>
      <ReachOutSection
        title={reachOut.title}
        description={reachOut.description}
        formFields={reachOut.formFields}
        category={category}
        id="reach-out"
      />
      <Footer />
    </div>
  );
};
